import { useContext } from 'react';
import { useStore as useZustandStore } from 'zustand';

import { NofomoCartStoreContext } from './context';
import { NofomoCartStore } from './zustand';

export const useCartStore = <T>(selector: (store: NofomoCartStore) => T): T => {
  const nofomoStoreContext = useContext(NofomoCartStoreContext);

  if (nofomoStoreContext === null) {
    throw new Error(`useCartStore must be use within NofomoStoreProvider`);
  }

  return useZustandStore(nofomoStoreContext, selector);
};

export const useCartStoreActions = () => useCartStore((state) => state.actions);
